import { render, staticRenderFns } from "./AdminPromoCodesAdd.vue?vue&type=template&id=3fad1202"
import script from "./AdminPromoCodesAdd.vue?vue&type=script&lang=js"
export * from "./AdminPromoCodesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports